import { BASE_CORE_URL, UAPI_URL_CONFIG } from "../config"

//#region Api Calling For NotifiacationConfiguartion GetUserBysite
export const getRegisteredUsers = async (siteIds, pageNumber, searchText) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        }
    }
    let url = UAPI_URL_CONFIG + "notification/getUserBySite?siteIds=" + siteIds + "&pageNumber=" + pageNumber + "&searchText=" + searchText;
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch(err => console.log(err));
}
//#endregion

//#region Api Calling for NotificationConfiguartion Mentions(PlaceHolder)
export const getMentionsList = async () => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        }
    }
    let url = UAPI_URL_CONFIG + "notification/mentionValue/";
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => { 
            return data;
        })
        .catch(err => console.log(err));
}
//#endregion

//#region Api Calling for Get Notification
export const getNotifs = async () => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        }
    }
    let url = UAPI_URL_CONFIG + "notification/getAllNotificationConfiguration?UserId=" + localStorage.getItem('UserID')
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch(err => console.log(err));
}
//#endregion

//#region Api Calling for Add Notification
export const addNotifs = async (obj) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        },
        body: JSON.stringify(obj)
    }
    let url = UAPI_URL_CONFIG + "notification/addNotificationConfiguration"
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch(err => console.log(err))
}
//#endregion

//#region Api Calling For Update Notification 
export const updateNotifs = async (obj) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        },
        body: JSON.stringify(obj)
    }
    let url = UAPI_URL_CONFIG + "notification/updateNotificationConfiguration/";
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch(err => console.log(err))
}
//#endregion

//#region Api Calling for GetNotificationById 
    
export const getNotifById = async (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        }
    }
    let url = UAPI_URL_CONFIG + `notification/getAllNotificationConfigurationById?UserID=${localStorage.getItem('UserID')}&NotificationConfigurationID=${id}`;
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch(err => console.log(err))
}
//#endregion

//#region Api Calling for DeleteNotification
export const deleteNotifs = async (userId, id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        },
    }
    // let url = BASE_CORE_URL + "NotificationConfiguration/Delete";
    let url = UAPI_URL_CONFIG + `notification/deleteNotification?userId=${userId}&notifId=${id}`;

    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch(err => console.log(err))
}
//#endregion

export const getEmergencyContactList = async (userId,siteIds) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        }
    }
    let url = UAPI_URL_CONFIG + "notification/getEmergencyContactBySite?userId=" + userId + "&siteIds=" + siteIds;
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch(err => console.log(err));
}